import "./filter.scss";

import iconClose from "images/cross.svg";
import iconFilter from "images/iconFilter.svg";
import { useState } from "react";

const Filter = ({
  handleFilter,
  handleClose,
  title,
  disabled,
  numOfFilters,

  ...props
}) => {
  const [isFilterOpened, setFilterOpened] = useState(false);
  return (
    <>
      <div className="position-relative">
        <button
          className={isFilterOpened ? "filter__btn filter__btn_active" : "filter__btn"}
          onClick={() => {
            setFilterOpened(!isFilterOpened);
          }}
        >
          <img
            src={iconFilter}
            alt="filter"
          />
          {
            numOfFilters && numOfFilters() > 0
              ? <span className="filter-nums">{numOfFilters()}</span>
              : null
          }
        </button>
        {
          isFilterOpened
            ? <>
              <div className="filter">
                <div className="filter__header d-flex justify-content-between align-items-center">
                  <p className="m-0">Фильтр</p>
                  <img
                    src={iconClose}
                    alt="close"
                    onClick={() => {
                      setFilterOpened(false);
                      handleClose && handleClose();
                    }}
                  />
                </div>
                <div className="filter__body">
                  {
                    props.children.length
                      ? <div className="filter__menu">
                        {props.children[1]}
                      </div>
                      : null
                  }
                  <div className={!props.children.length ? "filter__submenu" : "filter__submenu filter__submenu_border"}>
                    <p className="mb-2">{title}</p>
                    {props.children.length ? props.children[0] : props.children}
                  </div>
                </div>
                <div className={props.children.length ? "filter-btn-container" : "text-center"}>
                  <button className="filter__btn" disabled={disabled} onClick={() => {
                    handleFilter();
                    setFilterOpened(false);
                  }}>
                    Сбросить
                  </button>
                </div>
              </div>
              <div className="filter-backdrop"></div>
            </>
            : null
        }
      </div>
    </>
  );
};

export default Filter;